module.exports = __webpack_public_path__ + "img/4H.e241cdb6.png";